<template>
  <form-select
    class="special-func-select"
    v-model="val"
    :options="options"
    @change="change"
    v-on="$listeners"
  ></form-select>
</template>
<script>
export default {
  name: 'special-func-select',
  props: {
    lang: String,
    profile: String,
    category: String,
    value: [String, Number],
  },
  model: {
    prop: 'value',
    event: 'setval',
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      },
    },
  },
  data() {
    return {
      options: [],
      areamap: {},
    }
  },
  // created() {
  //   this.getFunc()
  // },
  methods: {
    findArea(funcArea, area) {
      if (Array.isArray(funcArea)) {
        for (var item of funcArea) {
          if (item.area == area) {
            return item
          }
        }
      }
      return null
    },
    getFunc() {
      this.$post('view/getFunc', {
        category: this.category,
        lang: this.lang,
        profile: this.profile,
      })
        .then((resp) => {
          if (resp.data.code == 0 && resp.data.data.length > 0) {
            var options = []
            this.areamap = {}
            for (var item of resp.data.data) {
              if (this.areamap[item.func]) {
                var areaItem = this.findArea(this.areamap[item.func], item.area)
                if (areaItem) {
                  areaItem.versions.push(item.version)
                } else {
                  this.areamap[item.func].push({
                    packid: item.packid,
                    area: item.area,
                    versions: [item.version],
                  })
                }
              } else {
                this.areamap[item.func] = [
                  {
                    packid: item.packid,
                    area: item.area,
                    versions: [item.version],
                  },
                ]
                options.push(
                  Object.assign(
                    {
                      label: item.func,
                      value: item.id,
                    },
                    item
                  )
                )
              }
            }
            this.options = options
            this.val = null
            if (options.length > 0) {
              this.$nextTick(() => {
                this.val = options[0].value
                this.$emit('outArea', options[0], this.areamap[options[0].func])
              })
            }
          } else {
            this.$message('获取功能失败')
          }
        })
        .catch((error) => {
          this.$message('获取功能发生错误=>' + error)
        })
    },
    change(newVal) {
      for (var item of this.options) {
        if (item.id == newVal) {
          this.$emit('outArea', item, this.areamap[item.func])
        }
      }
    },
  },
  watch: {
    profile() {
      this.getFunc()
    },
  },
}
</script>
<style lang="less">
.special-func-select {
  width: 100px;
}
</style>